import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { ruTr } from './rulocale';
import { i18nSharedConfig } from '@bepro-travel/fe.shared';
import { i18nConfig } from '@bepro-travel/fe.ui';
import { OphirFilterModel } from './ts/classes/OphirFilterModel';
import { TourPackageDeal } from './ts/interfaces/OphirResponse';
import { OphirSuccessResponse, RoomsClass } from './ts/interfaces/OphirBook';

export const i18nconfig = () => {
  localStorage.setItem('language', 'ru');

  const translation = ruTr;

  i18n.use(initReactI18next).init({
    resources: {
      ru: {
        translation,
      },
    },
    lng: 'ru',
    fallbackLng: 'ru',

    interpolation: {
      escapeValue: false,
    },
  });

  i18nSharedConfig({ enTranslation: {}, heTranslation: {}, ruTranslation: translation });
  i18nConfig({ enTranslation: {}, heTranslation: {}, ruTranslation: translation });
};

export const filtering = (filter: OphirFilterModel, packages: TourPackageDeal[]) => {
  const newPackages = packages?.map((resert) => {
    const filterByNights = filter.nights.some((item) => item.checked);
    const filterByPackage = filter.packages.some((item) => item.checked);
    const filterByHotel = !!filter.selectedHotel;

    const priceFiltered =
      filter.prices.value[0] <= resert.price.onePersonPrice &&
      resert.price.onePersonPrice <= filter.prices.value[1];
    const nightsFiltered = filterByNights
      ? filter.nights.find((item) => item.count === resert.nightsCount)?.checked
      : true;
    const packagesFiltered = filterByPackage
      ? filter.packages.find((item) => item.name === resert.boardDescription)?.checked
      : true;
    const hotelFiltered = filterByHotel ? filter.selectedHotel === resert.hotelName : true;

    let countryFiltered = true;
    if (filter.selectedCountries.length) {
      const countryCodes = filter.countries
        .filter((country) => filter.selectedCountries.includes(country.value as string))
        .map((country) => country.value);
      countryFiltered = countryCodes.length ? countryCodes.includes(resert.countryCode) : true;
    }

    let monthFiltered = true;
    if (filter.selectedMonths.length) {
      const dateCodes = filter.selectedMonths.map((month) => {
        const [day, mon, year] = month.split('-');
        return new Date(+year, +mon, +day).getMonth();
      });
      monthFiltered = dateCodes.length ? dateCodes.includes(resert.checkInMonthNumber) : true;
    }

    const visible =
      priceFiltered &&
      nightsFiltered &&
      packagesFiltered &&
      hotelFiltered &&
      countryFiltered &&
      monthFiltered;

    return { ...resert, visible: !!visible };
  });

  return newPackages;
};

export const sorting = (sorter: { by: string; order: string }, packages: TourPackageDeal[]) => {
  const newPackages = packages.sort((a, b) => {
    if (sorter.by === 'name') {
      if (sorter.order === 'asc') {
        return a.hotelName.localeCompare(b.hotelName);
      } else {
        return b.hotelName.localeCompare(a.hotelName);
      }
    } else {
      if (sorter.order === 'asc') {
        return a.price.onePersonPrice - b.price.onePersonPrice;
      } else {
        return b.price.onePersonPrice - a.price.onePersonPrice;
      }
    }
  });

  return newPackages;
};

export const getClassNameByStatus = (status?: string) => {
  if (status === 'OK') return 'ok';
  if (status === 'XX') return 'err';
  return 'warning';
};

export const getTextByStatus = (status?: string) => {
  if (status === 'OK') return 'OK';
  if (status === 'XX') return 'Not Confirmed';
  return status;
};

export const getPackagePassengerValidation = (index: number) => {
  const baseValidation = {
    firstName: { required: true, minLength: 2, maxLength: 20, english: true },
    lastName: { required: true, minLength: 2, maxLength: 20, english: true },
    phone: {},
    email: {},
    passportNumber: { required: true },
    passportValidTill: { required: true },
    email2: { required: true, length: 9, numbers: true },
  };
  if (index === 0) {
    return {
      ...baseValidation,
      email: { required: true, email: true },
      phone: { required: true },
    };
  } else {
    return baseValidation;
  }
};

export const getImgUrl = (url: string, cdnUrl: string) => {
  return cdnUrl + '/backend' + url;
};
interface UniqueRoom {
  qnt: number;
  roomClass: RoomsClass;
}

export const pushDataLayer = (data: OphirSuccessResponse) => {
  try {
    const uniqueRooms = data.data.roomsClasses.reduce((acc: UniqueRoom[], item) => {
      const existingIndex = acc.findIndex(
        (uniqueItem) =>
          uniqueItem.roomClass.room[0].roomType.desc === item.room[0].roomType.desc &&
          uniqueItem.roomClass.room[0].salePrice === item.room[0].salePrice,
      );

      if (existingIndex === -1) {
        acc.push({
          qnt: 1,
          roomClass: item,
        });
      } else {
        acc[existingIndex].qnt++;
      }

      return acc;
    }, []);

    const items = uniqueRooms.map((room) => {
      return {
        item_id: data.data.deals[0].id, //this is bepro segment
        item_name: data.data.deals[0].package.name,
        coupon: '',
        discount: 0,
        index: 1,
        item_brand: 'Ophir ru',
        item_category: data.data.deals[0].package.remark,
        item_category2: data.data.deals[0].package.name,
        item_category3: '',
        item_category4: '',
        item_category5: '',
        item_list_id: '',
        item_list_name: '',
        item_variant: room.roomClass.room[0].roomType.desc,
        option: 'INTERNET',
        price: room.roomClass.room[0].salePrice,
        quantity: room.qnt,
      };
    });

    const newDataLayer = {
      event: 'purchase',
      ecommerce: {
        transaction_id: data.transactionId,
        value: data.data.totalPrice,
        tax: 0,
        shipping: 0,
        currency: data.data.currency,
        coupon: '',
        items: items,
      },
    };

    setTimeout(() => {
      if (typeof (window as any).dataLayer !== 'undefined') {
        (window as any).dataLayer.push({ ecommerce: null });
        (window as any).dataLayer.push(newDataLayer);
      }
    }, 1000);
  } catch (e) {
    console.error(e);
  }
};

export function htmlToBase64(html: string): string {
  const uint8Array = new TextEncoder().encode(html);
  let binary = '';
  for (let i = 0; i < uint8Array.length; i++) {
    binary += String.fromCharCode(uint8Array[i]);
  }
  return btoa(binary);
}
